import { render } from "./PlatformWindows.vue?vue&type=template&id=10986d40&scoped=true&ts=true"
import script from "./PlatformWindows.vue?vue&type=script&lang=ts"
export * from "./PlatformWindows.vue?vue&type=script&lang=ts"

import "./PlatformWindows.vue?vue&type=style&index=0&id=10986d40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10986d40"]])

export default __exports__